import { Position, VisualAlertFieldType } from '@keepeek/commons';
import { computeTextToDisplay } from './computeTextToDisplay.js';
import { convertVisualAlertPositionToTagPosition } from './convertVisualAlertPositionToTagPosition.js';
import { getFieldValue } from './getFieldValue.js';
import { isDateEligibleToDisplayVisualAlert } from './isDateEligibleToDisplayVisualAlert.js';
import { isSubStatusEligibleToDisplayVisualAlert } from './isSubStatusEligibleToDisplayVisualAlert.js';

/**
 *
 * @param visualAlertsConf Visual alert configuration from Admin ReFront
 * @param element media
 * @param position wished position
 * @returns A list of TagProps for potentials Tags of the media
 */
function getVisualAlertsData(visualAlertsConf, element, position, currentLocale) {
    if (currentLocale === void 0) { currentLocale = "fr"; }
    var tags = [];
    if (!visualAlertsConf) {
        return tags;
    }
    tags =
        visualAlertsConf
            .filter(function (visualAlertConf) {
            if ((!(visualAlertConf === null || visualAlertConf === void 0 ? void 0 : visualAlertConf.position) && position === Position.TopRight) ||
                ((visualAlertConf === null || visualAlertConf === void 0 ? void 0 : visualAlertConf.position) &&
                    convertVisualAlertPositionToTagPosition(visualAlertConf.position) === position)) {
                // if no conf about position is present (old configurations) and the wished position by component is TOP_RIGHT
                // if the position wished by component is the one in the current configuration
                return true;
            }
            return false;
        })
            .filter(function (visualAlertConf) {
            // depending on the type of the field check if the rules are respected and if the Tag has to be displayed
            if (visualAlertConf.fieldType === VisualAlertFieldType.Date) {
                return isDateEligibleToDisplayVisualAlert(element, visualAlertConf.fieldInternalName, visualAlertConf.dateTargetMode, visualAlertConf.dateTargetNumber, visualAlertConf.dateTargetUnit);
            }
            else if (visualAlertConf.fieldType === VisualAlertFieldType.SubStatus) {
                return isSubStatusEligibleToDisplayVisualAlert(element, visualAlertConf.subStatusId);
            }
            return false;
        })
            .map(function (visualAlertConf) {
            var _a;
            var textValueForCurrentLocale = ((_a = visualAlertConf.text.find(function (t) { return t.language.toString().toLowerCase() === currentLocale; })) === null || _a === void 0 ? void 0 : _a.value) || "";
            var fieldValue = visualAlertConf.fieldInternalName
                ? getFieldValue(element, visualAlertConf.fieldInternalName)
                : undefined;
            var textValueToDisplay = computeTextToDisplay(textValueForCurrentLocale, fieldValue, visualAlertConf.displayFieldValue, element);
            var tag = {
                title: textValueToDisplay,
                backgroundColor: visualAlertConf.backgroundColor,
                textColor: visualAlertConf.color,
                borderRadius: visualAlertConf.borderRadius,
                fontSize: visualAlertConf.fontSize,
                marginBottom: visualAlertConf.marginBottom,
                marginLeft: visualAlertConf.marginLeft,
                marginRight: visualAlertConf.marginRight,
                marginTop: visualAlertConf.marginTop,
                padding: visualAlertConf.padding,
                position: convertVisualAlertPositionToTagPosition(visualAlertConf.position),
                dateTargetMode: visualAlertConf.dateTargetMode,
                dateTargetNumber: visualAlertConf.dateTargetNumber,
                dateTargetUnit: visualAlertConf.dateTargetUnit,
                fieldInternalName: visualAlertConf.fieldInternalName,
                element: visualAlertConf.element,
                fieldType: visualAlertConf.fieldType,
                subStatusId: visualAlertConf.subStatusId,
                displayFieldValue: visualAlertConf.displayFieldValue
            };
            return tag;
        }) || [];
    return tags;
}

export { getVisualAlertsData };
//# sourceMappingURL=getVisualAlertsData.js.map
